export const STEP_TYPE = "type";
export const STEP_SYSTEM = "system";
export const STEP_MODEL = "model";
export const STEP_MATERIAL = "material";
export const STEP_KNOCK = "knock";
export const STEP_CONTACT = "contact";

export const STEPS = [
    STEP_TYPE,
    STEP_SYSTEM,
    STEP_MODEL,
    STEP_MATERIAL,
    STEP_KNOCK,
    STEP_CONTACT,
];
